export enum CompanionProductGroupId {
    ROUTER_WHOLEBUY = 150,
    ROUTER_WOWI = 155,
    TV_STICK = 301,
}
